<div class="sidenav" style="overflow: hidden !important;">
  <a
    id="my-maps"
    class="sidebar-elements"
    routerLink="/dashboard/maps"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    >Maps</a
  >
  <a
    id=" dashboard_addson"
    class="sidebar-elements"
    routerLink="/dashboard/addOns"
    routerLinkActive="active"
    >Add-ons</a
  >
  <a
    id="dashboard_collab"
    class="sidebar-elements"
    routerLink="/dashboard/collaboration"
    routerLinkActive="active"
    >Collaboration</a
  >
  <a
    id="profile_payment"
    class="sidebar-elements"
    routerLink="/dashboard/profile"
    routerLinkActive="active"
    >Profile and Payment</a
  >
</div>
